import React from 'react';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {ThemeProvider, CssBaseline} from '@mui/material';
import theme from './theme';
import Home from './pages/Home';
import Header from "./components/Header";
import Team from "./pages/Team";
import Projects from "./pages/Projects";
import Wood from "./pages/Wood";
import About from "./pages/About";

const App: React.FC = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Header />
                <Routes>
                    <Route path="*" element={<Navigate to="/" />} />
                    <Route path="/" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/team" element={<Team />} />
                    <Route path="/wood" element={<Wood />} />
                    <Route path="/about" element={<About />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default App;
